function DocumentReducer(state = {
    documentList: [], documentsFilter: {}, balanceReport: [], accBookReport: [], creditorDebtorList: [], accBookFilters: {},
    cheqSearchFilters: {}, cheqSearchList: { Data: [], TotalCount: 0, accountsReport: {} }
}, action) {
    switch (action.type) {
        case "SEARCH_DOCUMENTS":
            return {
                ...state,
                documentList: action.data
            }
        case "SEARCH_DOCUMENTS_FILTER":
            return {
                ...state,
                documentsFilter: action.data
            }
        case "BALANCE_REPORT":
            return {
                ...state,
                balanceReport: action.data
            }
        case "BALANCE_REPORT_FILTERS":
            return {
                ...state,
                balanceReportFilters: action.data
            }
        case "ACCOUNTS_BOOK_REPORT":
            return {
                ...state,
                accBookReport: action.data
            }
        case "CREDITOR_DEBTOR_LIST":
            return {
                ...state,
                creditorDebtorList: action.data
            }
        case "CREDITOR_DEBTOR_FILTERS":
            return ({
                ...state,
                creditorDebtorFilters: action.data
            })
        case "ACCOUNTS_BOOK_FILTERS":
            return {
                ...state,
                accBookFilters: action.data
            }
        case "CHEQ_SEARCH_FILTERS":
            return {
                ...state,
                cheqSearchFilters: action.data
            }
        case "SEARCH_CHEQUE":
            return {
                ...state,
                cheqSearchList: action.data
            }
        case "GET_ACCOUNTS_REPORT":
            return {
                ...state,
                accountsReport: action.data
            }
        case "ACCOUNTS_REPORT_FILTERS":
            return {
                ...state,
                accountReportFilters: action.data
            }
        default:
            return state;
    }
}
export default DocumentReducer;